import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { Router } from '@angular/router';

import { SecurityService } from './security.service';

@Injectable({
  providedIn: 'root',
})
export class SecurityGuard  {
  constructor(
    private router: Router,
    private securityService: SecurityService
  ) {}

  canActivate(): Observable<boolean> {
    return new Observable((subscribe: Subscriber<boolean>) => {
      if (this.securityService.valid) {
        subscribe.next(true);
      } else {
        this.router.navigate(['/login']);
        subscribe.next(false);
      }
    });
  }
}
